export default "__VITE_ASSET__BQRw19kU__"